module.exports = __webpack_public_path__ + "img/TESL_Wounded-Knee.b28fde62.jpg";